import { defineProvider } from '@nuxt/image/runtime';

// I don't know how to type this, check https://image.nuxtjs.org/advanced/custom-provider if they updated docs
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default defineProvider({
  // @ts-ignore
  getImage(src: string, { modifiers, baseURL } = {}, { options, nuxtContext, $img }) {
    const { width, height, format, ...providerModifiers } = modifiers;

    let url = src;
    const params = [];
    if (width) {
      params.push(`w=${width}`);
    }
    if (height) {
      params.push(`h=${height}`);
    }
    if (providerModifiers?.quality) {
      params.push(`q=${providerModifiers.quality}`);
    }
    // @ts-ignore - see the note above; @nuxt/image v2's modifiers type doesn't include `format`
    if (providerModifiers?.format) {
      // @ts-ignore
      params.push(`f=${providerModifiers.format}`);
    } else if (format) {
      params.push(`f=${format}`);
    }
    if (params.length) {
      url += '?' + params.join('&');
    }

    return {
      url,
    };
  },
});
